import Editor from "~/js/editor";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import {
	fullscreenLinkedList,
	setFullScreenValues,
	setIsFullScreenModalShown
} from "~/solidJs/entities/FullScreenViewerEntity/models/fullScreenModel";
import { setCanvasStore } from "~/solidJs/entities/MagicBrushCanvas";
import { helperCreateObjectUrl } from "~/solidJs/shared/helpers";
import { SidebarModes, toggleSidebarWidget } from "~/solidJs/shared/helpers/toggleSidebarWidget";
import { getImageDimensionsFromFile } from "~/solidJs/shared/helpers/validateImages";
import { initImageViewerHoverMenu } from "~/solidJs/widgets/HoverFeatureMenu";
import Viewer from "../viewer";
export default class ImageViewer extends Viewer {
	static type = "image";
	static supportedExtensions = ["png", "jpg", "jpeg", "webp"];
	constructor(asset, socketOutput, socketName) {
		super(asset, socketOutput, socketName);
		this.initSizeDom();
		this.dom.viewer.addEventListener("click", () => this.showFullscreenWithThisImage());

		// Initialize new hover feature menu (replaces old hover buttons)
		if (socketOutput && socketName) {
			this.hoverMenuCleanup = initImageViewerHoverMenu(this, socketOutput, socketName);
		}
	}
	findIndexOfSelf() {
		return this.socketsOutput.node
			.getSocketsOut()
			.findIndex((socket) => socket.name === this.socketName);
	}
	initSizeDom() {
		const parent = this.dom.viewerContainer;
		this.dom.sizeContainer = document.createElement("div");
		this.dom.sizeContainer.className =
			"text-2xs flex absolute left-0 bottom-0 gap-2 flex-col rounded-md p-1 bg-white";
		parent.append(this.dom.sizeContainer);
	}
	// Hover functionality now handled by SolidJS HoverFeatureMenu

	initFullScreenImage() {
		this.fullScreenInited = true;
		this.fullScreenNode = fullscreenLinkedList.createUnShiftNode({
			nodeUuid: this.socketsOutput.node.uuid,
			asset: this.asset
		});
	}

	showFullscreenWithThisImage() {
		EventAnalytics.hoverMenuInteraction("full-screen");
		this.changeFullScreenPreviewSrcByIndex();
		setFullScreenValues({
			activeItem: this.fullScreenNode
		});
		setIsFullScreenModalShown(true);
	}

	changeFullScreenPreviewSrcByIndex() {
		this.fullScreenNode.value.asset = this.asset;
	}

	remove() {
		const newNode = fullscreenLinkedList.deleteNode(this.fullScreenNode);
		setFullScreenValues({
			activeItem: newNode
		});
	}

	// Hover methods moved to HoverFeatureMenu handlers
	// All hover methods moved to HoverFeatureMenu/handlers.ts

	async loadAsync() {
		const assetToLoad = this.asset;
		const size = await getImageDimensionsFromFile(assetToLoad);
		// sizeImageInLimits(
		// 	assetToLoad,
		// 	{
		// 		heightLimit: 1024,
		// 		widthLimit: 1024
		// 	},
		// 	{
		// 		heightLimit: 0,
		// 		widthLimit: 0
		// 	}
		// ).then((scaledImage) => {
		// 	if (assetToLoad !== this.asset || !scaledImage) return;
		// 	const url = helperCreateObjectUrl(scaledImage);
		// 	this.dom.image.src = url;
		// });
		const url = helperCreateObjectUrl(this.asset);
		this.url = url;
		this.dom.image = document.createElement("img");
		// this.dom.image.loading = "lazy";
		// this.dom.image.decode = "async";
		this.dom.image.onload = () => {
			this.changeImageTextSize(
				size?.height || this.dom.image.naturalHeight,
				size?.width || this.dom.image.naturalWidth
			);
		};
		this.dom.image.classList.add("imageViewer");
		this.dom.image.src = url;
		this.domElement().append(this.dom.image);
		this.initFullScreenImage();
	}

	async getAssetUrl() {
		return this.url;
	}

	// All remaining hover methods moved to HoverFeatureMenu/handlers.ts

	// Keep utility methods that are used by handlers
	variationHandler(isNeedToExecute = true) {
		return createVariation.call(this, undefined, isNeedToExecute);
	}

	addImageToCanvas = async () => {
		const asset = await this.getAsset();
		setCanvasStore({
			url: await this.getAssetUrl(),
			name: asset.name.split(".")[0],
			fromNodeId: this.socketsOutput.node.uuid,
			fromNodeSocketName: this.socketName,
			mode: "inpainting"
		});
		toggleSidebarWidget(SidebarModes.Inpaint);
	};
	changeImageTextSize(height, width) {
		this.dom.sizeContainer.textContent = `size ${width} x ${height}`;
	}
	reloadAssetAsync(asset) {
		this.asset = asset;
		const url = helperCreateObjectUrl(this.asset);
		this.url = url;
		this.dom.image.onload = () => {
			this.changeImageTextSize(this.dom.image.naturalHeight, this.dom.image.naturalWidth);
		};
		this.dom.image.src = url;
		this.changeFullScreenPreviewSrcByIndex();
		fullscreenLinkedList.unshiftNode(this.fullScreenNode);
	}
}

async function createVariation(moduifyCopiedParams, isNeedToExecute = true) {
	const [copiedParams] = await Editor.context.graph.serializeNodesAndThierConnections([
		this.socketsOutput.node
	]);
	copiedParams.globalId = "Phygital Creator/phygc-rnd-comfy-flux";
	copiedParams.position = getPositionToTheRightWithPadding(this.socketsOutput.node);
	copiedParams.connections.push({
		from: {
			nodeUuid: this.socketsOutput.node.uuid,
			name: this.socketName
		},
		to: {
			nodeUuid: copiedParams.uuid,
			name: "init_img"
		}
	});
	copiedParams.params.denoise = {
		name: "denoise",
		value: 0.65
	};
	moduifyCopiedParams?.(copiedParams);
	const variationNode = await Editor.context.graph.pasteNodeByGlobalidAndParams(copiedParams);
	Editor.context.graph.pasteConnectionsFromTemplateParams(copiedParams);

	if (!isNeedToExecute) return variationNode;
	if (isFetchesExternalModels(variationNode.definition)) {
		variationNode.eventor.addListener(NodeEvents.MyModalsWasFetched, () => {
			variationNode.execute();
		});
		return variationNode;
	}
	setTimeout(() => {
		setTimeout(() => variationNode.execute());
	});
	return variationNode;
}
export class CropperViewer extends ImageViewer {
	getAssetFile;

	/**
	 *
	 * @param {*} getAssetFile
	 * @param  {...any} args
	 */
	constructor(getAssetFile, ...args) {
		super(...args);
		this.getAssetFile = getAssetFile;
	}

	initSizeDom() {
		const parent = this.dom.viewer;
		this.dom.sizeContainer = document.createElement("div");
		this.dom.sizeContainer.className =
			"text-2xs flex absolute left-0 -bottom-6 gap-2 flex-col rounded-md p-1 bg-white";
		parent.append(this.dom.sizeContainer);
	}

	changeImageTextSize(height, width) {
		this.dom.sizeContainer.textContent = `size ${width} x ${height}`;
	}

	async getAssetUrl() {
		return helperCreateObjectUrl((await this.getAssetFile()) || this.asset);
	}

	async initFullScreenImage() {
		this.asset = await this.getAsset();
		super.initFullScreenImage();
	}

	async changeFullScreenPreviewSrcByIndex() {
		this.asset = await this.getAsset();
		super.changeFullScreenPreviewSrcByIndex();
	}
	async showFullscreenWithThisImage() {
		EventAnalytics.hoverMenuInteraction("full-screen");
		await this.changeFullScreenPreviewSrcByIndex();
		setFullScreenValues({
			activeItem: this.fullScreenNode
		});
		setIsFullScreenModalShown(true);
	}
	async downloadAsset() {
		const asset = await this.getAsset();
		if (asset) {
			downloadAsset(asset);
		}
	}

	getAsset() {
		return this.getAssetFile();
	}
}
